module.exports = __webpack_public_path__ + "static/media/exo-latin-500.5622502d.woff2";